import { render, staticRenderFns } from "./gsr_ttxh_report.vue?vue&type=template&id=4b33e6f7&scoped=true"
import script from "./gsr_ttxh_report.vue?vue&type=script&lang=js"
export * from "./gsr_ttxh_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33e6f7",
  null
  
)

export default component.exports